/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelinboxempty2Inputs */

const en_channelinboxempty2 = /** @type {(inputs: Channelinboxempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No replies yet.`)
};

const de_channelinboxempty2 = /** @type {(inputs: Channelinboxempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Antworten.`)
};

/**
* | output |
* | --- |
* | "No replies yet." |
*
* @param {Channelinboxempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelinboxempty2 = /** @type {((inputs?: Channelinboxempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelinboxempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelinboxempty2(inputs)
	return de_channelinboxempty2(inputs)
});
export { channelinboxempty2 as "channelInboxEmpty" }